import { TextCollection, ApiResponse, HttpResponse } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data';

export const api = {

  /**
   * Fetch tranlated texts for a given application area and language
   */
  textCollection: async (language: number, area: number): Promise<HttpResponse<ApiResponse<TextCollection>>> => {

    return await new RemoteData('text/collection')
      .resource<HttpResponse<ApiResponse<TextCollection>>>()
      .withId(area)
      .filter({ language })
      .response();
  }

};
